
import { MinimalContentData } from '@rtl/api'
import { mixins, Options, Prop } from 'vue-property-decorator'

import ContentDecoratorMixin from '../../mixins/ContentDecoratorMixin'
import VideoPlayer from '../VideoPlayer.vue'
import ContentCard from './ContentCard.vue'

@Options({
  name: 'RecommendedVideoList',
  components: {
    VideoPlayer,
    ContentCard
  }
})
export default class RecommendedVideoList extends mixins(ContentDecoratorMixin) {
  items: Array<MinimalContentData> = []
  autoplay = false
  campaignNumber = '1'

  @Prop({ type: Number, default: 4 })
  readonly length!: number

  @Prop({ type: Array<MinimalContentData>, default: [] })
  readonly contents!: Array<MinimalContentData>

  get bigContent (): MinimalContentData | null {
    return this.items[0] || null
  }

  get secondColContents (): Array<MinimalContentData> {
    return this.items.slice(1, this.length) || []
  }

  get medium () {
    return this.bigContent?.title ? this.bigContent?.title.replace(/ /g,"_") : null
  }

  swapVideo (id: string, num: number) {
    this.autoplay = true
    this.campaignNumber = num.toString()
    const i = this.items.findIndex(item => item.id === id)
    if (i > 0) {
      const target = this.items[i]
      this.items[i] = this.items[0]
      this.items[0] = target
    }
  }

  mounted () {
    this.items = [...this.contents]
  }
}
